module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "loadingScreen"
    }
  }, [_c('md-spinner', {
    staticClass: "md-warn",
    style: ({
      visibility: _vm.visibility
    }),
    attrs: {
      "md-size": 150,
      "md-stroke": 1.5,
      "md-indeterminate": ""
    }
  }), _vm._v(" "), (!_vm.errorInLoadingData) ? _c('h3', {
    staticClass: "loading-text"
  }, [_vm._v("Nalagam Podatke")]) : _vm._e(), _vm._v(" "), (_vm.errorInLoadingData) ? _c('h3', {
    staticClass: "loading-text"
  }, [_vm._v("Verjetno je prišlo do neke napake na serverju")]) : _vm._e(), _vm._v(" "), (_vm.errorInLoadingData) ? _c('md-button', {
    staticClass: "md-raised",
    on: {
      "click": _vm.tryAgain
    }
  }, [_vm._v("Poskusi še enkrat")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a43e5832","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loadingScreen.vue
// module id = 71
// module chunks = 0